<template>
  <div>
    <h6 class="heading-small text-muted mb-4">Report Template</h6>
    <a-spin :spinning="formLoading">
      <form>
        <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
          <div v-if="!creatingTemplate">
            <div class="row">
              <div class="col-9">
                <base-input label="Report Templates">
                  <a-select
                    show-search
                    v-model="selectedAccountReportTemplateId"
                    :filter-option="filterReportTemplateOption"
                    @change="onChangeReportTemplate"
                  >
                    <a-select-option
                      v-for="reportTemplate in options.accountReportTemplates"
                      :value="reportTemplate.id"
                      :key="reportTemplate.id"
                    >
                      {{ reportTemplate.name }}
                    </a-select-option>
                  </a-select>
                  <small v-if="fieldsUpdated || (updatedFilter && !disableForm)"
                    ><i>*Modified</i></small
                  >
                </base-input>
              </div>

              <!-- <div class="col-3">
                <base-button
                  type="primary btn-block"
                  size="sm"
                  class="my-4"
                  @click.prevent="setCreatingTemplate(true)"
                >
                  New
                </base-button>
              </div> -->
            </div>
          </div>

          <div v-else>
            <div class="row">
              <div class="col-9">
                <base-input label="Template Name" required>
                  <a-input v-model.trim="$v.formData.name.$model" />
                  <div v-if="$v.formData.name.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.name.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
              <!-- <div class="col-3">
                <base-button
                  type="primary btn-block"
                  size="sm"
                  class="my-4"
                  @click.prevent="setCreatingTemplate(false)"
                >
                  Select
                </base-button>
              </div> -->
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Description">
                  <a-textarea
                    v-model="formData.description"
                    :auto-size="{ minRows: 5, maxRows: 5 }"
                  />
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </form>

      <a-tabs default-active-key="fields">
        <a-tab-pane key="template-fields" tab="Fields">
          <div class="list-group list-group-item">
            <div class="row">
              <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
              <div class="col-md-6">
                <a-checkbox
                  class="float-right"
                  @change="onCheckAllField"
                  v-model="checkAll"
                  :disabled="
                    disableForm ||
                    accountReport.code == 'SCRATCH_CARD_REPORTS_AGGREGATE'
                  "
                />
              </div>
            </div>
          </div>
          <draggable
            :v-model="accountReportColumns"
            :list="accountReportColumns"
            :disabled="
              disableForm ||
              accountReport.code == 'SCRATCH_CARD_REPORTS_AGGREGATE'
            "
            class="list-group"
            ghost-class="ghost"
            @change="
              () => {
                this.columnOrderChange = true;
                this.fieldsUpdated = true;
              }
            "
            @move="moveColumn"
            @start="drag = true"
            @end="drag = false"
          >
            <div
              class="list-group-item"
              v-for="(column, index) in accountReportColumns"
              :key="index"
            >
              <div class="row">
                <div class="col-md-6">
                  {{ column.title }}
                  <small v-if="column.group">(group)</small>
                </div>
                <div class="col-md-6">
                  <a-checkbox
                    class="float-right"
                    @change="onCheckField"
                    v-model="column.value"
                    :disabled="
                      disableForm ||
                      accountReport.code == 'SCRATCH_CARD_REPORTS_AGGREGATE'
                    "
                  />
                </div>
              </div>
            </div>
          </draggable>
          <br />
          <div>
            <b-button
              v-if="columnOrderChange"
              size="sm"
              variant="danger"
              @click.prevent="sortColumn"
            >
              Reset Order
            </b-button>
          </div>
        </a-tab-pane>
        <a-tab-pane
          v-if="dynamicFormColumns"
          class="mb-5"
          key="template-dynamic-fields"
          tab="Dynamic Fields"
        >
          <div
            class="list-group-item"
            v-for="(item, index) in dynamicFormColumns"
            :key="index"
          >
            <div class="row">
              <div class="col-md-6">
                {{ item['title'] }}
              </div>
              <div class="col-md-6">
                <a-checkbox
                  class="float-right"
                  v-model="item.value"
                  @change="onCheckField"
                  :disabled="disableForm"
                />
              </div>
            </div>
          </div>
        </a-tab-pane>

        <!--a-tab-pane key="template-filters" tab="Filters">
          <div class="row">
            <div class="col">
              <base-input>
                <b-form-checkbox
                  v-model="captureFilters"
                  name="check-button"
                  switch
                  :disabled="disableForm"
                  @change="setUpdatedFields"
                >
                  <label class="form-control-label">Capture Filtering</label>
                </b-form-checkbox>
              </base-input>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="template-sorts" tab="Sorts">
          <div class="row">
            <div class="col">
              <base-input>
                <b-form-checkbox
                  v-model="captureSorts"
                  name="check-button"
                  switch
                  :disabled="disableForm"
                  @change="setUpdatedFields"
                >
                  <label class="form-control-label">Capture Sorting</label>
                </b-form-checkbox>
              </base-input>
            </div>
          </div>
        </a-tab-pane-->
      </a-tabs>
    </a-spin>

    <div
      style="
        position: absolute;
        bottom: 0px;
        right: 0px;
        width: -webkit-fill-available;
        background-color: #f2f2f2;
        padding: 10px;
      "
    >
      <div class="container mx-0 px-0">
        <div class="row">
          <div class="col-auto">
            <template>
              <a-spin :spinning="formSubmitting">
                <b-button
                  v-if="creatingTemplate === true"
                  size="sm"
                  @click.prevent="createAccountReportTemplate"
                  variant="primary"
                >
                  Save Template
                </b-button>

                <b-button
                  v-else-if="creatingTemplate !== true && disableForm !== true"
                  size="sm"
                  variant="danger"
                  @click.prevent="deleteTemplate"
                >
                  Delete
                </b-button>
                <b-button
                  v-if="creatingTemplate !== true"
                  size="sm"
                  variant="danger"
                  @click.prevent="closeDrawer"
                >
                  Close
                </b-button>
              </a-spin>
            </template>
          </div>
          <div v-if="creatingTemplate !== true" class="col text-right">
            <b-button
              v-if="
                (disableForm !== true && this.fieldsUpdated == true) ||
                (updatedFilter && !disableForm)
              "
              size="sm"
              variant="primary"
              class="align-self-end"
              @click.prevent="updateAccountReportTemplate"
            >
              Save
            </b-button>
            <b-button
              size="sm"
              variant="warning"
              @click.prevent="setCreatingTemplate(true)"
            >
              Save As
            </b-button>
          </div>
          <div v-else class="col text-right">
            <b-button
              size="sm"
              variant="danger"
              class="align-self-end"
              @click.prevent="setCreatingTemplate(false)"
            >
              Cancel
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import HTTPRequest from '../../../controllers/httpRequest';
import draggable from 'vuedraggable';

export default {
  name: 'AccountReportTemplateForm',
  components: {
    draggable
  },
  props: {
    accountReport: Object,
    accountReportTemplate: Object,
    selectedAccountReportTemplateColumns: Array,
    dynamicFormColumns: Array,
    selectedAccountReportTemplateFilters: Object,
    selectedAccountReportTemplateSorts: Array,
    updatedFilter: Boolean
  },
  data() {
    return {
      columnOrderChange: true,
      checkAll: false,
      drag: false,
      accountReportColumns: [],
      formSubmitting: false,
      formLoading: false,
      hasCardAssignmentModule: false,
      creatingTemplate: false,
      fieldsUpdated: false,
      captureFilters: false,
      captureSorts: false,
      selectedAccountReportTemplate: null,
      selectedAccountReportTemplateId: null,
      selectedAccountReportTemplateExtas: {},
      selectedColumns: [],
      selectedFilters: {},
      selectedSorts: [],
      formData: {
        account_report_id: this.accountReport.id,
        name: null,
        description: null,
        config: {
          columns: [],
          filters: [],
          sorts: []
        },
        extras: {
          capture_filters: false,
          capture_sorts: false
        }
      },
      options: {
        accountReportTemplates: []
      }
    };
  },

  validations: {
    formData: {
      name: { required }
    }
  },

  methods: {
    async getCardAssignmentFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_ASSIGNMENT_FEATURE`
      );

      if (response.account_id) {
        this.hasCardAssignmentModule = response.value == 'true';
      }
    },
    keyChecker(obj, key) {
      return Object.keys(obj).includes(key);
    },
    sortColumn() {
      this.accountReportColumns = this.accountReportColumns.sort(
        (a, b) => a.index - b.index
      );
      this.columnOrderChange = false;
    },
    columnSorter(arrayJson) {
      let array = arrayJson;
      if (array.length > 0) {
        if (this.keyChecker(arrayJson[0], 'index')) {
          array = array.sort(
            (a, b) => parseFloat(a.index) - parseFloat(b.index)
          );
        } else {
          let index = 0;
          for (let obj of array) {
            obj['index'] = index;
            index++;
          }
        }
      }
      return array;
    },
    async getAccountReportTemplates() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/account_report_templates/' +
          this.accountReport.code +
          '/templates'
      );
      this.options.accountReportTemplates = data;
    },

    async getAccountReportTemplate(reportTemplateId) {
      const data = await HTTPRequest.getRequest(
        '/api/v1/account_report_templates/' + reportTemplateId
      );
      return data;
    },

    async updateAccountReportTemplate() {
      this.formSubmitting = true;
      this.reindexColumns();
      let filters = this.selectedFilters;
      if (this.keyChecker(filters, 'source')) {
        const spreadFilter = { ...filters };
        delete spreadFilter['source'];
        filters = spreadFilter;
      }
      this.formData.config = JSON.stringify({
        columns: this.accountReportColumns,
        filters: filters,
        meta: this.dynamicFormColumns,
        sorts: this.selectedSorts
      });

      this.formData.extras = JSON.stringify({
        capture_filters: this.captureFilters,
        capture_sorts: this.captureSorts
      });

      const accountReportTemplate = await HTTPRequest.putRequest(
        '/api/v1/account_report_templates/' +
          this.selectedAccountReportTemplateId,
        {
          account_report_template: this.formData
        }
      );

      if (accountReportTemplate.id) {
        this.closeDrawer();
        // this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Template has been updated.'
        });
        this.$emit('setAccountReportTemplate', null);
      } else {
        if (accountReportTemplate.error != undefined) {
          this.$notification.error({
            message: accountReportTemplate.error,
            placement: 'topLeft'
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.',
            placement: 'topLeft'
          });
        }
      }

      this.formSubmitting = false;
    },
    async createAccountReportTemplate() {
      this.formSubmitting = true;
      this.$v.formData.$touch();
      this.reindexColumns();

      if (!this.$v.formData.$invalid) {
        let filters = this.selectedFilters;
        if (this.keyChecker(filters, 'source')) {
          const spreadFilter = { ...filters };
          delete spreadFilter['source'];
          filters = spreadFilter;
        }
        this.formData.config = JSON.stringify({
          columns: this.accountReportColumns,
          filters: filters,
          meta: this.dynamicFormColumns,
          sorts: this.selectedSorts
        });

        this.formData.extras = JSON.stringify({
          capture_filters: this.captureFilters,
          capture_sorts: this.captureSorts
        });

        const accountReportTemplate = await HTTPRequest.postRequest(
          '/api/v1/account_report_templates/',
          {
            account_report_template: this.formData
          }
        );

        if (accountReportTemplate.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Template has been created.'
          });
          this.$emit('setAccountReportTemplate');
        } else {
          if (accountReportTemplate.error != undefined) {
            this.$notification.error({
              message: accountReportTemplate.error,
              placement: 'topLeft'
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.',
              placement: 'topLeft'
            });
          }
        }

        this.formSubmitting = false;
      }
    },
    reindexColumns() {
      for (let x = 0; x < this.accountReportColumns.length; x++) {
        this.accountReportColumns[x].index = x;
      }
    },
    onCheckField() {
      this.fieldsUpdated = true;
      this.checkColumnFalse();
      // this.$emit('setTableColumns', this.accountReportConfigColumns);
    },

    onCheckAllField() {
      if (this.checkAll) {
        for (let x = 0; x < this.accountReportColumns.length; x++) {
          this.accountReportColumns[x].value = true;
        }
      } else {
        for (let x = 0; x < this.accountReportColumns.length; x++) {
          this.accountReportColumns[x].value = false;
        }
      }
      this.fieldsUpdated = true;
      // this.$emit('setTableColumns', this.accountReportConfigColumns);
    },
    checkColumnFalse() {
      this.checkAll = true;
      if (typeof this.accountReportColumns == 'object') {
        for (let x = 0; x < this.accountReportColumns.length; x++) {
          if (!this.keyChecker(this.accountReportColumns[x], 'value')) {
            this.checkAll = false;
            break;
          }
          if (this.accountReportColumns[x].value == false) {
            this.checkAll = false;
            break;
          }
        }
      } else {
        this.checkAll = false;
      }
    },
    columnSelected(column) {
      let status = false;
      for (let x = 0; x < this.accountReportColumns.length; x++) {
        if (this.accountReportColumns[x].name == column.name) {
          if (!this.keyChecker(this.accountReportColumns[x], 'value')) {
            status = this.accountReportColumns[x].value = false;
          } else {
            status = this.accountReportColumns[x].value;
          }
        }
      }
      return status;
    },

    setAccountReportTemplate(accountReportTemplate) {
      const { name, description } = accountReportTemplate;
      this.formData.name = name;
      this.formData.description = description;

      this.selectedAccountReportTemplate = accountReportTemplate;
      this.selectedAccountReportTemplateExtas =
        JSON.parse(accountReportTemplate.extras) || {};
      const sorts = JSON.parse(accountReportTemplate.config).sorts || [];
      const filters = JSON.parse(accountReportTemplate.config).filters || {};
      let meta = JSON.parse(accountReportTemplate.config).meta || null;
      if (meta) {
        for (const newObj of this.dynamicFormColumns) {
          const index = meta.findIndex((obj) => obj.name === newObj.code);
          if (index === -1) {
            meta.push({
              name: newObj.code,
              type: newObj.type,
              title: newObj.title,
              value: newObj.value
            });
          } else {
            meta[index].type = newObj.type;
            meta[index].title = newObj.title;
            meta[index].name = newObj.name;
          }
          meta = meta.filter((obj) => {
            return this.dynamicFormColumns.some(
              (newObj) => newObj.code === obj.name
            );
          });
        }
        this.dynamicFormColumns = meta;
      } else {
        if (this.dynamicFormColumns) {
          for (let x = 0; x < this.dynamicFormColumns.length; x++) {
            this.dynamicFormColumns[x].value = false;
          }
        }
      }

      // this.captureFilters = this.selectedAccountReportTemplateExtas.capture_filters;
      // this.captureSorts = this.selectedAccountReportTemplateExtas.capture_sorts;

      this.captureFilters = true;
      this.captureSorts = true;

      this.selectedAccountReportTemplateId = accountReportTemplate.id;

      /** Set selected columns */
      this.selectedColumns = this.setSelectedColumns(
        JSON.parse(accountReportTemplate.config).columns
      );
      this.setAccountReportColumns(this.selectedColumns);
      this.checkColumnFalse();

      if (this.captureFilters) {
        /** Save filters to local scope variable if $captureFilters = true */
        this.selectedFilters = filters;
      } else {
        this.selectedFilters = {};
      }

      if (this.captureSorts) {
        /** Save filters to local scope variable if $captureSorts = true */
        this.selectedSorts = sorts;
      } else {
        this.selectedSorts = [];
      }

      /** formData related */
      this.formData.name = accountReportTemplate.name;
      this.formData.description = accountReportTemplate.description;
      this.fieldsUpdated = false;
      this.columnOrderChange = false;
    },

    setCreatingTemplate(bool) {
      this.creatingTemplate = bool;
      if (bool) {
        this.selectedAccountReportTemplateId = null;
      } else {
        this.selectedAccountReportTemplateId = this.accountReportTemplate.id;
      }
    },

    async onChangeReportTemplate(reportTemplateId) {
      this.formLoading = true;
      const accountReportTemplate = await this.getAccountReportTemplate(
        reportTemplateId
      );
      this.setAccountReportTemplate(accountReportTemplate);
      this.$emit('setUpdatedFilter');

      this.formLoading = false;
      this.fieldsUpdated = false;
    },

    closeDrawer() {
      this.$emit('closeDrawer', null);
    },

    filterReportTemplateOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async deleteTemplate() {
      const deleteResponse = await HTTPRequest.deleteRequest(
        '/api/v1/account_report_templates/' +
          this.selectedAccountReportTemplateId
      );
      try {
        if (deleteResponse.message == 'Success') {
          this.$notification.success({ message: 'Template deleted' });
          this.$emit('deleteAccountReportTemplate', null);
          this.$root.$emit('refreshTable');
          this.closeDrawer();
        }
      } catch (e) {
        console.log(e);
        this.$notification.error({ message: 'Error deleting template.' });
      }
    },
    setUpdatedFields() {
      this.fieldsUpdated = true;
    },
    moveColumn(event) {
      const { futureIndex, index } = event.draggedContext;
      const tempHolder = this.accountReportColumns[futureIndex];
      this.accountReportColumns[futureIndex] = this.accountReportColumns[index];
      this.accountReportColumns[index] = tempHolder;
    },
    setSelectedColumns(columns) {
      let selectedColumns;
      if (typeof columns != 'object') {
        selectedColumns = [];
      } else {
        selectedColumns = columns;
      }
      const accountReportConfigColumns = JSON.parse(
        this.accountReport.config
      ).columns;
      for (const accountReportConfigColumn of accountReportConfigColumns) {
        let inConfigColumn = false;
        for (let selectedColumns of selectedColumns) {
          if (selectedColumns.name == accountReportConfigColumn.name) {
            inConfigColumn = true;
          }
        }
        if (!inConfigColumn) {
          selectedColumns.push(accountReportConfigColumn);
        }
      }
      return selectedColumns;
    },
    setAccountReportColumns(columns) {
      const accountReportConfig = JSON.parse(this.accountReport.config);
      let defaultReportColumns = accountReportConfig.columns;
      if (columns != null) {
        if (columns.length > 0) {
          if (this.keyChecker(columns[0], 'index')) {
            for (const column of columns) {
              for (let x = 0; x < defaultReportColumns.length; x++) {
                if (column.name == defaultReportColumns[x].name) {
                  defaultReportColumns[x].index = column.index;
                  defaultReportColumns[x].value = column.value;
                }
              }
            }
          }
          if (!this.keyChecker(columns[0], 'value')) {
            for (let x = 0; x < defaultReportColumns.length; x++) {
              if (!this.keyChecker(defaultReportColumns[x], 'value')) {
                defaultReportColumns[x].value = true;
              }
            }
          }
        }
      }
      defaultReportColumns = this.columnSorter(defaultReportColumns);
      if (this.hasCardAssignmentModule) {
        defaultReportColumns = defaultReportColumns.filter(
          (item) =>
            item.name !== 'serial_no' &&
            item.name !== 'batch_number' &&
            item.name !== 'barcode' &&
            item.name !== 'card_type_name'
        );
      }
      this.accountReportColumns = defaultReportColumns;
    }
  },
  computed: {
    disableForm() {
      return (
        this.selectedAccountReportTemplateId ===
        this.accountReport.accountReportTemplates[0].id
      );
    }
  },

  async created() {
    /** Fetch templates available for the report */
    await this.getAccountReportTemplates();
    await this.getCardAssignmentFeature();

    /** Set the "current" report template for the page */
    this.setAccountReportTemplate(this.accountReportTemplate);
  },

  watch: {
    captureFilters: function (capture) {
      if (capture === true) {
        this.selectedFilters = this.selectedAccountReportTemplateFilters;
      } else {
        this.selectedFilters = {};
      }
    },

    captureSorts: function (capture) {
      if (capture === true) {
        this.selectedSorts = this.selectedAccountReportTemplateSorts;
      } else {
        this.selectedSorts = {};
      }
    }
  }
};
</script>

<style scoped></style>
